import { render, staticRenderFns } from "./LeadBoardColumnCard.vue?vue&type=template&id=5b178a70&"
import script from "./LeadBoardColumnCard.vue?vue&type=script&lang=js&"
export * from "./LeadBoardColumnCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports